import { render, staticRenderFns } from "./InstitutionsReport.vue?vue&type=template&id=109f484e"
import script from "./InstitutionsReport.vue?vue&type=script&lang=js"
export * from "./InstitutionsReport.vue?vue&type=script&lang=js"
import style0 from "./InstitutionsReport.vue?vue&type=style&index=0&id=109f484e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports